import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import parse from '../../../../utils/parse';

import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

import LogoUrl from '../../../../resources/logo.svg';
import DownloadIconUrl from '../../../../resources/icons/download-icon-black.svg';
import UrlIcon from '../../../../resources/icons/url-icon-black.svg';

import ShareButton from './ShareButton';

import {
  WEBSITE_URL,
  MENU_HIERARCHY,
  MENU_DESKTOP_WIDTH,
  DOWNLOAD_TEXT,
  PDF_NAME_HR,
  SLIDES_LINKS,
} from '../../../../config';

import styles from '../styles';

class DesktopAppMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentHighlightedItem: null,
      isHover: false,
    }
  }
  /**
   * HANDLE
   */
  handleMouseEnter(evt, params = null) {
    const setState = {
      isHover: true,
    };
    if (params) {
      setState.currentHighlightedItem = params;
    }
    this.setState(setState);
  }

  handleMouseLeave(evt) {
    const { relatedTarget, toElement } = evt.nativeEvent;
    if (relatedTarget) {
      if (relatedTarget.classList.contains('bookmarkButton')) {
        return;
      }
      if (relatedTarget.closest('.subDrawer')) {
        return;
      }
    }
    if (toElement) {
      if (toElement.classList.contains('bookmarkButton')) {
        return;
      }
      if (toElement.closest('.subDrawer')) {
        return;
      }
    }
    this.setState({ isHover: false });
  }

  /**
   * RENDER
   */
  renderMainDrawer() {
    const { classes, page, fullscreen, onNavigate } = this.props;
    return (
      <Drawer
        className={classes.mainDrawer}
        variant="persistent"
        anchor="left"
        open={!fullscreen}
      >
        <Box className={classes.mainDrawerHeader}>
          <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
            <img src={LogoUrl} alt="Agence Luciole" />
          </a>
        </Box>
        <List sx={{ overflowY: 'auto', overflowX: 'hidden' }}>
          {MENU_HIERARCHY.map((item, idx) => {
            const isFocus = page >= item.pages[0] && page <= item.pages[1];
            return (
              <ListItem key={item.label} className={`${classes.listItem} ${item.color} ${isFocus ? 'focus' : ''}`} disablePadding>
                <ListItemButton
                  className="bookmarkButton"
                  sx={{ pt: idx === 0 ? '4px' : 0, pb: idx === 0 ? '4px' : 0 }}
                  onClick={() => onNavigate(item.pages[0])}
                >
                  <ListItemText
                    className={`${classes.drawerLabel} ${item.color} category`}
                    primary={<Typography variant="h3">{parse(item.label)}</Typography>}
                    secondary={<span className={`listItemFocus ${item.color}`}></span>}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>

        <Stack className={classes.socialList} justifyContent='center' style={{ paddingBottom: '32px' }}>
          <Stack>
            {/* 👉 Bouton lien externe */}
            {SLIDES_LINKS[page] && (
              <ListItem key="external-link" className={classes.listItem} disablePadding>
                <ListItemButton
                  onClick={() => {
                    window.open(SLIDES_LINKS[page], '_blank');

                    if (window.umami) {
                      window.umami.track(`Portfolio RA - External Link - ${page}`);
                    }
                  }}
                >
                  <ListItemIcon>
                    <img
                      className={classes.menuIcon}
                      src={UrlIcon}
                      alt="Voir le projet"
                    />
                  </ListItemIcon>
                  <ListItemText
                    className={classes.drawerLabel}
                    primary={<Typography variant="h4" color="primary.main">Voir le projet</Typography>}
                  />
                </ListItemButton>
              </ListItem>
            )}
            <ShareButton classes={classes} />

            {/* 👉 Ton bouton download (inchangé) */}
            <ListItem key="download" className={classes.listItem} disablePadding>
              <ListItemButton
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = `${window.location.pathname}${PDF_NAME_HR}`;
                  link.download = 'LUCIOLE-RA-2026.pdf';
                  link.click();

                  if (window.umami) {
                    window.umami.track(`Portfolio RA - Download`);
                  }
                }}
              >
                <ListItemIcon>
                  <img className={classes.menuIcon} src={DownloadIconUrl} alt={DOWNLOAD_TEXT} />
                </ListItemIcon>
                <ListItemText
                  className={`${classes.drawerLabel}`}
                  primary={<Typography variant="h4">{DOWNLOAD_TEXT}</Typography>}
                />
              </ListItemButton>
            </ListItem>

          </Stack>
        </Stack>
      </Drawer>
    );
  }

  render() {
    const { classes, fullscreen } = this.props;
    return (
      <Stack
        className={classes.desktopMenuContainer}
        sx={{ width: fullscreen ? 0 : MENU_DESKTOP_WIDTH }}
        direction="row"
      >
        {this.renderMainDrawer()}
      </Stack>
    );
  }
}

DesktopAppMenu.defaultProps = {
  page: 0,
};

DesktopAppMenu.propTypes = {
  // props
  fullscreen: PropTypes.bool,
  page: PropTypes.number,
  fileURL: PropTypes.string,
  fileURLDownload: PropTypes.string,
  // funcs
  onNavigate: PropTypes.func.isRequired,
};

export default withStyles(styles)(DesktopAppMenu);
